<div class="modal-content modal-milvus" style="zoom: 0.85;">
    <div class="modal-header">
        <h6 class="modal-title" id="modal-title-default" [translate]="'VINCULAR_CONTATOS'"></h6>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modal.close()">
            <i class="mdi mdi-close"></i>
        </button>
    </div>
    <div class="modal-body">
        <ng-container *ngIf="nomes.length > 1">
            <div class="row">
                <div class="col-12 form-group">
                    <label [translate]="'SELECIONE_NOME_CONTATO_VINCULO'" style="font-size: 16px;"></label>
                    <div *ngFor="let nome of nomes" class="col-6 d-flex">
                        <label class="radio-box">
                            <input type="radio" name="{{'nome_' + nome}}" id="{{'nome_' + nome}}"
                                [checked]="contatoFinal.contato_agregador_novo.descricao"
                                [(ngModel)]="contatoFinal.contato_agregador_novo.descricao" [value]="nome">
                            <span class="checkmark"></span>
                        </label>
                        <label style="font-weight: normal;">{{nome}}</label>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="emails.length > 1">
            <div class="row">
                <div class="col-12 form-group">
                    <label [translate]="'SELECIONE_EMAIL_CONTATO_VINCULO'" style="font-size: 16px;"></label>
                    <div *ngFor="let email of emails" class="col-6 d-flex">
                        <label class="radio-box">
                            <input type="radio" name="{{'email_' + email}}" id="{{'email_' + email}}"
                                [checked]="contatoFinal.contato_agregador_novo.email"
                                [(ngModel)]="contatoFinal.contato_agregador_novo.email" [value]="email">
                            <span class="checkmark"></span>
                        </label>
                        <label style="font-weight: normal;">{{email}}</label>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="celulares.length > 1">
            <div class="row">
                <div class="col-12 form-group">
                    <label [translate]="'SELECIONE_CELULAR_CONTATO_VINCULO'" style="font-size: 16px;"></label>
                    <div *ngFor="let celular of celulares" class="col-6 d-flex">
                        <label class="radio-box">
                            <input type="radio" name="{{'celular_' + celular}}" id="{{'celular_' + celular}}"
                                [checked]="contatoFinal.contato_agregador_novo.celular"
                                [(ngModel)]="contatoFinal.contato_agregador_novo.celular" [value]="celular">
                            <span class="checkmark"></span>
                        </label>
                        <label style="font-weight: normal;">{{celular | mask:celular.length === 11 ? '(00) 00000-0000' :
                            '(00)
                            0000-0000'}}</label>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="telefones.length > 1">
            <div class="row">
                <div class="col-12 form-group">
                    <label [translate]="'SELECIONE_TELEFONE_CONTATO_VINCULO'" style="font-size: 16px;"></label>
                    <div *ngFor="let telefone of telefones" class="col-6 d-flex">
                        <label class="radio-box">
                            <input type="radio" name="{{'telefone_' + telefone}}" id="{{'telefone_' + telefone}}"
                                [checked]="contatoFinal.contato_agregador_novo.telefone"
                                [(ngModel)]="contatoFinal.contato_agregador_novo.telefone" [value]="telefone">
                            <span class="checkmark"></span>
                        </label>
                        <label style="font-weight: normal;">{{telefone | mask:telefone.length === 11 ? '(00) 00000-0000'
                            : '(00)
                            0000-0000'}}</label>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="modal-footer modal-footer-milvus">
        <button type="button" class="btn btn-integration badge-pill" (click)="vincularContatos()">
            <span>{{ "VINCULAR" | translate }}</span>
        </button>
    </div>
</div>